<template>
    <el-container>
        <td-permission :permissions="permissionsView">
            <div slot="havePermission">
                <el-aside class="aside-classify-tree">
                    <td-tree
                        :lazyloading="lazyloading"
                        :draggable="draggable"
                        :isDbClick="true"
                        :calInternal="true"
                        :isClick="true"
                        :imgloading="true"
                        :typeContent="typeContent"
                        :checkStrictly="false"
                        ref="TdTree"
                        @onDbClick="onClick"
                        @onClick="onClick"
                        :showBox="false"
                        :dragLevel="true"
                        :isPaging="true"
                        :expandOnClick="true"
                        :defaultProps="defaultProps"
                        :nodeKey="nodeKey"
                        :isDistributed="false"
                        :interfaceName="interfaceName"
                        :inputShow="inputShow"
                        :params="params"
                        @nodeDrop="nodeDrop"
                    >
                    </td-tree>
                </el-aside>
            </div>
        </td-permission>
        <el-container>
            <el-header>
                <td-permission :permissions="permissionsView">
                    <div slot="havePermission">
                        <el-row :gutter="20" class="paddingLeft10 paddingTop10">
                            <p>{{ tableName }}</p>
                        </el-row>
                    </div>
                </td-permission>
                <el-form :inline="true" :model="formDataManage" ref="formDataManage" @submit.native.prevent>
                    <td-permission :permissions="permissionsView">
                        <div slot="havePermission">
                            <el-form-item :label="$t('pgCommon.PROPERTY_NAME')">
                                <td-select
                                    :placeholder="$t('pgCommon.PLEASE_SELECT')"
                                    :options="this.displayPropertyList"
                                    v-model="formDataManage.sColumnName"
                                    keys="sColumnName"
                                    text="sColumnNotes"
                                ></td-select>
                            </el-form-item>
                            <el-form-item :label="$t('pgCommon.VALUE')">
                                <td-input v-model="formDataManage.sColumnValue"></td-input>
                            </el-form-item>
                        </div>
                    </td-permission>
                    <el-form-item class="paddingLeft10">
                        <td-button type="primary" :permissions="permissionsView" :loading="loading" @click="btnQuery" @keyup.enter.native="btnQuery">{{ $t('pgCommon.QUERY') }}</td-button>
                        <td-button type="button" :permissions="permissionsView" @click="btnAdvancedQuery">{{ $t('pgCommon.ADVANCED_QUERY') }}</td-button>
                        <td-button type="button" :permissions="permissionsAdd" @click="btnAddManage">{{ $t('pgCommon.ADD') }}</td-button>
                        <!-- <td-button type="button" :permissions="permissionsImport" @click="btnImport">{{ $t('pgCommon.IMPORT') }}</td-button>
                        <td-button type="button" :permissions="permissionsExport" :loading="epLoading" @click="btnExport">{{ $t('pgCommon.EXPORT') }}</td-button> -->
                        <td-button type="button" :permissions="permissionsDel" :loading="deleteLoading" @click="btnDeleteData">{{ $t('pgCommon.DELETE_BATCH') }}</td-button>
                    </el-form-item>
                </el-form>
            </el-header>
            <el-main>
                <td-permission :permissions="permissionsView" style="width:100%">
                    <div slot="havePermission">
                        <!-- 加载数据表格 -->
                        <td-table
                            :columns="columns"
                            :dataSource="tableData"
                            :pageSize="pageSize"
                            :currentPage="currentPage"
                            :total="total"
                            :hasIndex="false"
                            @handleSizeChange="handleSizeChange"
                            @currentChange="currentChange"
                            ref="tableInfo"
                        ></td-table>
                    </div>
                </td-permission>
                <!-- 加载高级查询dialog -->
                <dialog-advance-query
                    v-if="dialogAdvancedVisible"
                    :dialogAdvancedVisible="dialogAdvancedVisible"
                    :title="title"
                    :propertyList="allPropertyList"
                    @advanceQuery="advanceQuery"
                    @dialogAdvanceClose="dialogAdvanceClose"
                ></dialog-advance-query>
                <!-- 加载数据添加编辑dialog -->
                <dialog-data-manage
                    v-if="dialogManageVisible"
                    :dialogManageVisible="dialogManageVisible"
                    :title="title"
                    :isAddData="isAddData"
                    :propertyList="allPropertyList"
                    :editItem="editItem"
                    :nowTreeItem="nowTreeItem"
                    @dialogManageClose="dialogManageClose"
                    @queryDataList="queryDataList"
                ></dialog-data-manage>
                <!-- 加载导入dialog -->
                <dialog-data-import
                    v-if="dialogImportDataVisible"
                    :dialogImportDataVisible="dialogImportDataVisible"
                    :title="title"
                    :sysFlg="sysFlg"
                    :treeNode="this.nowTreeItem"
                    ref="uploadExcel"
                    @dialogImportDataClose="dialogImportDataClose"
                    @queryDataList="queryDataList"
                ></dialog-data-import>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import dataApi from './assets/api.js';
import dialogAdvanceQuery from './components/dialogAdvanceQuery.vue';
import dialogDataManage from './components/dialogDataManage.vue';
import dialogImportData from './components/dialogImportData.vue';
export default {
    props: {
        treeList: {
            type: Array,
            default: function() {
                return [];
            }
        },
        lazyloading: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        defaultProps: {
            type: Object,
            default: function() {
                return {
                    children: 'children',
                    label: 'sName',
                    id: 'sId',
                    imgName: 'sIcon'
                };
            }
        },
        imgloading: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        calInternal: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        typeContent: {
            type: Array,
            default: function() {
                return [];
            }
        },
        isClick: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        isDbClick: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        draggable: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        inputName: {
            type: String,
            default: function() {
                return 'component.PLEASE_ENTER_NAME';
            }
        },
        // 树形是否分页
        isPaging: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 搜索框是否显示
        inputShow: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        height: {
            type: Number,
            default: function() {
                return 800;
            }
        }
    },
    // 初始化渲染
    components: {
        'dialog-data-manage': dialogDataManage,
        'dialog-advance-query': dialogAdvanceQuery,
        'dialog-data-import': dialogImportData
    },
    created() {
        this.columns = this.$util.clone(this.baseColumns);
    },
    mounted() {
        // 为编辑状态则进行初始化数据
        this.queryPropertyList();
    },
    // 定义数据
    data() {
        return {
            permissionsView: ['configTable:view'],
            permissionsAdd: ['configTable:add'],
            permissionsDel: ['configTable:del'],
            permissionsEdit: ['configTable:edit'],
            permissionsImport: ['configTable:import'],
            permissionsExport: ['configTable:export'],
            nodeKey: 'sId',
            formDataManage: {
                sColumnName: '',
                sColumnValue: ''
            },
            tableName: '未选择',
            defaultWidth: '1500',
            isAddData: false,
            allPropertyList: [],
            displayPropertyList: [],
            dialogAdvancedVisible: false,
            dialogManageVisible: false,
            dialogImportDataVisible: false,
            columns: [],
            tableData: [],
            checkList: [],
            conditionList: [], // 高级条件
            nowTreeItem: [], // 当前选中树形节点
            treePicture: {}, // 树形图标列表
            editItem: {}, //选中行信息
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            epLoading: false,
            deleteLoading: false,
            baseColumns: [
                {
                    prop: '',
                    label: window.vue.$t('pgCommon.OPERATE'),
                    tableWidth: this.defaultWidth,
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnExit([params.row]);
                                        }
                                    }
                                },
                                window.vue.$t('pgCommon.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.delete(params.row);
                                        }
                                    }
                                },
                                window.vue.$t('pgCommon.DELETE')
                            )
                        ]);
                    }
                }
            ],
            interfaceName: { query: '/setting/tableController/findTrusteeshipTree', search: '/setting/tableController/searchTreeQuery' },
            params: {
                currentPage: 1,
                needPage: true,
                pageSize: 50
            }
        };
    },
    methods: {
        // 树形点击事件
        onClick(item) {
            if (item == null) {
                return;
            }
            this.currentPage = 1;
            this.nowTreeItem = item;
            if (item.type === window.pgCommon.sType.database) {
                this.tableName = item.sName;
                return;
            } else {
                this.tableName = item.sDatabaseName + ' > ' + item.sName + '(' + item.sTableName + ')';
            }
            this.queryPropertyList();
            this.queryDataList();
        },

        // 查询属性信息
        queryPropertyList() {
            let formData = new FormData();
            if (this.nowTreeItem == null || this.nowTreeItem.length < 1) {
                return;
            }
            formData.append('sTrusteeshipId', this.nowTreeItem.sId);
            dataApi.initMasterDataAddPage(formData, response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.loading = false;
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/setting/dataController/initMasterDataAddPage', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.displayPropertyList = response.data.content.displayFields;
                this.allPropertyList = response.data.content.allFields;
                this.createTitle();
            });
        },

        // 创建表头
        createTitle() {
            // 生成表头
            let cl = this.$util.clone(this.baseColumns);
            cl[0].tableWidth = '90px';
            for (let i = 0; i < this.displayPropertyList.length; i++) {
                if (this.displayPropertyList[i].sFieldType == null || this.displayPropertyList[i].sFieldType == '' || this.displayPropertyList[i].sFieldType === undefined) {
                    continue;
                }
                let label = '';
                if (this.displayPropertyList[i].sFieldType === window.pgCommon.sFieldType.sKeyField) {
                    label = this.$t('pgCommon.KEY_FIELD');
                } else if (this.displayPropertyList[i].sFieldType === window.pgCommon.sFieldType.sValueField) {
                    label = this.$t('pgCommon.VALUE_FIELD');
                } else if (this.displayPropertyList[i].sFieldType === window.pgCommon.sFieldType.sDescField) {
                    label = this.$t('pgCommon.DESC_FIELD');
                }
                if (this.displayPropertyList[i].sColumnName != this.displayPropertyList[i].sColumnNotes) {
                    label += '(';
                    label += this.displayPropertyList[i].sColumnNotes;
                    label += ')';
                }
                let colItem = {
                    prop: this.displayPropertyList[i].sColumnName,
                    label: label,
                    align: 'center',
                    showOverflowTooltip: true
                };
                cl.splice(cl.length - 1, 0, colItem);
            }
            this.columns = cl;
        },

        // 查询表数据
        btnQuery() {
            this.currentPage = 1;
            this.loading = true;
            this.queryDataList();
        },

        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryDataList();
        },

        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryDataList();
        },

        // 获取查询参数
        getParam() {
            if (this.conditionList.length > 0) {
                this.formDataManage.sColumnName = '';
                this.formDataManage.sColumnValue = '';
            }
            if (this.formDataManage.sColumnName !== '' && this.formDataManage.sColumnName != null && this.formDataManage.sColumnValue == '') {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_INPUT_VALUE'), type: 'warning' });
                return;
            }
            if (this.formDataManage.sColumnName == '' && this.formDataManage.sColumnValue != '') {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT_PROPERTY'), type: 'warning' });
                return;
            }
            let queryVo = {
                needPage: true,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            };
            queryVo.trusteeshipId = this.nowTreeItem.sId;
            if (this.conditionList.length === 0) {
                if (this.formDataManage.sColumnName != '' && this.formDataManage.sColumnValue != '') {
                    let condition = [];
                    let param = {
                        field: this.formDataManage.sColumnName,
                        condition: 'LIKE',
                        value: this.formDataManage.sColumnValue
                    };
                    condition.push(param);
                    queryVo.condition = condition;
                }
            } else {
                queryVo.condition = this.conditionList;
            }
            return queryVo;
        },

        // 查询列表信息
        queryDataList() {
            if (this.nowTreeItem.length === 0 || this.nowTreeItem.type === window.pgCommon.sType.database) {
                this.loading = false;
                this.$message({ showClose: true, message: window.vue.$t('pgCommon.PLEASE_SELECT_TABLE'), type: 'warning' });
                return;
            }
            let param = this.getParam();
            
            dataApi.queryTableDatas(JSON.stringify(param), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.loading = false;
                    this.conditionList = [];
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('setting/tableController/listTrusteeshipTables', response.data.statusMessage);
                    this.loading = false;
                    this.conditionList = [];
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.conditionList = [];
                this.loading = false;
            });
        },

        // 导入
        btnImport() {
            if (this.nowTreeItem.length === 0 || this.nowTreeItem.type === window.pgCommon.sType.database) {
                this.$message({ showClose: true, message: window.vue.$t('pgCommon.PLEASE_SELECT_TABLE'), type: 'warning' });
                return;
            }
            this.title = this.$t('pgCommon.IMPORT_DATA');
            this.dialogImportDataVisible = true;
        },

        // 导出
        btnExport() {
            if (this.nowTreeItem.length === 0 || this.nowTreeItem.type === window.pgCommon.sType.database) {
                this.$message({ showClose: true, message: window.vue.$t('pgCommon.PLEASE_SELECT_TABLE'), type: 'warning' });
                return;
            }
            this.epLoading = true;
            let param = this.getParam();
            dataApi.exportData(JSON.stringify(param), response => {
                let blob = new Blob(['\ufeff' + response.data], { type: 'text/html;charset=UTF-8' });
                this.content = response.data;
                this.epLoading = false;
                // 汉字解码
                let filename = decodeURIComponent(response.headers['filename']);
                if (window.navigator.msSaveOrOpenBlob) {
                    // 兼容IE10
                    navigator.msSaveBlob(blob, filename);
                } else {
                    //  chrome/firefox
                    let aTag = document.createElement('a');
                    aTag.download = filename;
                    aTag.href = window.URL.createObjectURL(blob);
                    aTag.click();
                    URL.revokeObjectURL(aTag.href);
                }
            });
        },

        // 添加高级查询条件
        btnAdvancedQuery() {
            if (this.nowTreeItem.length === 0 || this.nowTreeItem.type === window.pgCommon.sType.database) {
                this.$message({ showClose: true, message: window.vue.$t('pgCommon.PLEASE_SELECT_TABLE'), type: 'warning' });
                return;
            }
            this.title = this.$t('pgCommon.ADVANCED_QUERY');
            this.dialogAdvancedVisible = true;
        },

        // 添加
        btnAddManage() {
            if (this.nowTreeItem.length === 0 || this.nowTreeItem.type === window.pgCommon.sType.database) {
                this.$message({ showClose: true, message: window.vue.$t('pgCommon.PLEASE_SELECT_TABLE'), type: 'warning' });
                return;
            }
            this.isAddData = true;
            this.editItem = null;
            this.title = this.$t('pgCommon.ADD_DATA');
            this.dialogManageVisible = true;
        },

        // 编辑
        btnExit(item) {
            this.isAddData = false;
            this.editItem = item[0];
            this.title = this.$t('pgCommon.EDIT_DATA');
            this.dialogManageVisible = true;
        },

        // 获取删除参数
        getDeleteParam(row) {
            let data = [];
            // 批量删除
            if (row == null) {
                let items = this.$refs.tableInfo.getSelectAllRows();
                for (let i = 0; i < items.length; i++) {
                    let dataList = [];
                    for (let j = 0; j < this.allPropertyList.length; j++) {
                        if (this.allPropertyList[j].iPrimaryKey === 1) {
                            let map = {};
                            map.key = this.allPropertyList[j].sColumnName;
                            map.value = items[i][this.allPropertyList[j].sColumnName];
                            dataList.push(map);
                        }
                    }
                    data.push(JSON.stringify(dataList));
                }
            } else {
                // 单个删除
                let dataList = [];
                for (let index = 0; index < this.allPropertyList.length; index++) {
                    if (this.allPropertyList[index].iPrimaryKey === 1) {
                        let map = {};
                        map.key = this.allPropertyList[index].sColumnName;
                        map.value = row[this.allPropertyList[index].sColumnName];
                        dataList.push(map);
                    }
                }
                data.push(JSON.stringify(dataList));
            }
            let deleteVo = {
                trusteeshipId: this.nowTreeItem.sId,
                data: data
            };
            return deleteVo;
        },

        // 批量删除
        btnDeleteData() {
            let items = this.$refs.tableInfo.getSelectAllRows();
            if (items == null || items.length === 0) {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT'), type: 'warning' });
                return;
            }
            this.$confirm(this.$t('pgCommon.DELETE_INFO_TIPS'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            }).then(() => {
                this.deleteLoading = true;
                let param = this.getDeleteParam();
                dataApi.deleteData(JSON.stringify(param), response => {
                    this.deleteLoading = false;
                    if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                        return;
                    }
                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('setting/tableController/deleteData', response.data.statusMessage);
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS'), type: 'success' });
                    this.queryDataList();
                });
            });
        },

        // 删除
        delete(row) {
            this.$confirm(this.$t('pgCommon.DELETE_INFO_TIPS'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: window.vue.$t('pgCommon.SURE'),
                cancelButtonText: window.vue.$t('pgCommon.CANCEL'),
                type: 'warning'
            }).then(() => {
                let param = this.getDeleteParam(row);
                dataApi.deleteData(JSON.stringify(param), response => {
                    if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                        return;
                    }
                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('setting/tableController/deleteData', response.data.statusMessage);
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS'), type: 'success' });
                    this.queryDataList();
                });
            });
        },

        // 高级查询
        advanceQuery(conditionList) {
            this.conditionList = conditionList;
            this.queryDataList();
        },

        // 关闭表编辑页面
        trusteeshipDialogClose() {
            this.dialogTrusteeshipVisible = false;
            this.queryDataList();
        },

        // 关闭高级搜索页面
        dialogAdvanceClose() {
            this.dialogAdvancedVisible = false;
            this.queryDataList();
        },

        // 关闭新增编辑画面
        dialogManageClose() {
            this.dialogManageVisible = false;
            this.queryDataList();
        },

        // 关闭数据导入页面
        dialogImportDataClose() {
            this.dialogImportDataVisible = false;
            this.queryDataList();
        }
    }
};
</script>
<style></style>
